module.exports = __webpack_public_path__ + "img/shutterComponents-all.d74b5d83.png";